import { CustomerBrandingDTO } from "../DTO/customerBrandingDTO";
import { BasicRequest } from "./basicRequest";

export class UpdateBrandingRequest extends BasicRequest{
    
    customerBranding!: CustomerBrandingDTO;

    constructor(){
        super();
    }
}